import Service from "./Service";
const baseurl = '/api/type-app';
export default {
    index() {
        return Service.get(`${baseurl}`);
    }
}
